import {BASE_API_URL} from '../constants'
import Token from "./Token";


export const UserBillingApi = {
    get: (page, limit) => {
        const limitParam = limit ? '&limit=' + limit : ''
        return fetch(
            BASE_API_URL + '/api/user/billing?page=' + page + limitParam,
            {
                method: 'GET',
                headers: {
                    Authorization: 'Bearer ' + Token.getToken()
                }
            },
        ).then(r => {
            if (r.ok) {
                return r.json()
            }
            throw new Error(r.statusText)
        })
    }
}